import axios, { Axios } from "axios";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Css/Manager.css";
import { Chart } from "primereact/chart";






function ManageCharts(props)
{

    const [ordersData,setOrdersData] = useState([]);
    const [registrationsData,setregistrationsData] = useState([]);
    const [articleVisitsData,setArticleVisitsData] = useState([]);
    const [topOrderedProducts,setTopOrderedProducts] = useState([]);
    const [chosenSellersData,setChosenSellersData] = useState([]);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const navigate = useNavigate();
    
    

    //داده های جداول **************************************************************************************
      

    // سفارشها:
    const orderschartData = {
            labels: ordersData.monthNames,
            datasets: [
            {
                label: "سفارش ها",
                data: ordersData.counts,
                fill: false,
                borderColor: "#42A5F5",
                tension: 0.4,
                showInLegend: false,
            },
          
            ],
        };


        // ارجاع به فروشنده ها:
       const sellerschartData = {
        labels: chosenSellersData.monthNames,
        datasets: [
            {
            label: chosenSellersData?.sellerNames ? chosenSellersData.sellerNames[0] : "",
            data:  chosenSellersData?.counts ? chosenSellersData?.counts[0] : "",
            backgroundColor: "#6c99beb0",
            },
            {
            label: chosenSellersData?.sellerNames ? chosenSellersData.sellerNames[1] : "",
            data:  chosenSellersData?.counts ? chosenSellersData?.counts[1] : "",
            backgroundColor: "#b27f4984",
            },
            {
            label: chosenSellersData?.sellerNames ? chosenSellersData.sellerNames[2] : "",
            data:  chosenSellersData?.counts ? chosenSellersData?.counts[2] : "",
            backgroundColor: "#28960a52",
            },
            {
            label: chosenSellersData?.sellerNames ? chosenSellersData.sellerNames[3] : "",
            data:  chosenSellersData?.counts ? chosenSellersData?.counts[3] : "",
            backgroundColor: "#80808094",
            },
            {
            label: chosenSellersData?.sellerNames ? chosenSellersData.sellerNames[4] : "",
            data:  chosenSellersData?.counts ? chosenSellersData?.counts[4] : "",
            backgroundColor: "#f13a3a94",
            },

        ],
        };

            // ثبت نام ها:
            const usersChartData = {
            labels:registrationsData.monthNames,
            datasets: [
            {
                type: "bar", // نوع اول: میله‌ای
                label: "",
                backgroundColor: "rgba(176, 176, 176, 0.6)",
                data: registrationsData.counts,
                showInLegend: false,
            },
            {
                type: "line", // نوع دوم: خطی
                label: "",
                borderColor: "hsla(27, 93%, 28%, 0.91)4",
                borderWidth: 2,
                fill: false,
                tension: 0.4,
                data: registrationsData.counts,
                showInLegend: false,
            },
            ],
                };




                // بازدید مقاله ها:
                const articlesChartData = {
                labels: articleVisitsData.articlesNames,
                datasets: [
                    {
                    label: "تعداد کل بازدید بعد از نگارش مقاله",
                    data: articleVisitsData.visits,
                    backgroundColor: "#00b99191",
                    },
                    
                ],
                };


                // محصولات پرطرفدار:
                const productsChartData = {
                  labels: topOrderedProducts.productsNames,
                    datasets: [
                        {
                        data: topOrderedProducts.counts,
                        backgroundColor: [
                            "#42A5F5",
                            "#66BB6A",
                            "#FFA726",
                            "#FF7043",
                            "#AB47BC",
                             "#FFC0CB",
                            "#008080",
                            "#FFD700",
                            "#A52A2A",
                            "#708090",
                        ],
                        hoverBackgroundColor: [
                            "#42A5F5",
                            "#66BB6A",
                            "#FFA726",
                            "#FF7043",
                            "#AB47BC",
                             "#FFC0CB",
                            "#008080",
                            "#FFD700",
                            "#A52A2A",
                            "#708090",
                        ],
                        borderWidth: 2, // خطوط مرزی ملایم‌تر
                        },
                    ],
                    };

                    const pieChartOptions = {
                    layout: {
                        padding: 0, // فاصله از اطراف (چپ، راست، بالا، پایین)
                    },
                    plugins: {
                        legend: {
                        position: "bottom", // انتقال لیبل‌ها به پایین
                        labels: {
                            color: "#495057",
                            font: {
                            family: "dana-bold",
                            size: 14,
                            },
                            padding: 20, // فاصله بین آیتم‌های legend
                        },
                        },
                    },
                    maintainAspectRatio: false, // برای کنترل بهتر ارتفاع و عرض
                    response:true,
                    };


       const chartOptions = {
        plugins: {
            legend: {
                labels: {
                    color: "#495057",
                    font: {
                        family: "dana-bold",
                        size: 16,
                    },
                    // اضافه کردن کنترل برای حذف مستطیل رنگی و label
                    generateLabels: (chart) => {
                        return chart.data.datasets
                            .map((dataset, i) => {
                                // اگر dataset showInLegend === false باشه، تو legend نشون داده نشه
                                if (dataset.showInLegend === false) return null;

                                return {
                                    text: dataset.label,
                                    fillStyle: dataset.backgroundColor || dataset.borderColor,
                                    hidden: !chart.isDatasetVisible(i),
                                    datasetIndex: i,
                                };
                            })
                            .filter((x) => x !== null); // حذف null ها
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "#495057",
                    font: {
                        family: "dana-bold",
                    },
                },
                grid: {
                    color: "#ebedef",
                },
            },
            y: {
                ticks: {
                    color: "#495057",
                    font: {
                        family: "dana-bold",
                    },
                },
                grid: {
                    color: "#ebedef",
                },
            },
        },
        maintainAspectRatio: false, // برای کنترل بهتر ارتفاع و عرض
                    response:true,
    };

//   ****************************************************************************************



    
   

// fetching chart data ******************************************************************************
    
    //get orders data:
    useEffect(() => {
    async function getOrdersData() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/orders/chartData", config)
      .then((result) => {
        if (result.status == 200) {
          setOrdersData(result.data);
          
          
        
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getOrdersData();
  },[]);



  //get registrations data:
    useEffect(() => {
    async function getRegistrationsData() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/users/getRegistrationsChartData", config)
      .then((result) => {
        if (result.status == 200) {
          setregistrationsData(result.data);
          
        console.log("getRegistrationsChartData",result.data)
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getRegistrationsData();
  },[]);


  //get articles visits data:
    useEffect(() => {
    async function getArticleVisitsData() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/articles/getVisitsChartData", config)
      .then((result) => {
        if (result.status == 200) {
          setArticleVisitsData(result.data);
        
        
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getArticleVisitsData();
  },[]);


   //get top 5 ordered products:
    useEffect(() => {
    async function getTopOrderedProducts() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/orders/getTopOrderedProducts", config)
      .then((result) => {
        if (result.status == 200) {
          setTopOrderedProducts(result.data);
          
        
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getTopOrderedProducts();
  },[]);

  //get number of times a seller has been chosen/per month (only for top 5 seller) :
    useEffect(() => {
    async function getChosenSellerData() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/orders/getChosenSellerData", config)
      .then((result) => {
        if (result.status == 200) {
          setChosenSellersData(result.data);
          
        
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getChosenSellerData();
  },[]);

/************************************************************************************ */

  

  
    

    return(

        <div id="manage-charts">

            <h2 style={{marginBottom:'50px'}}>
            آمار سایت فلیکا (در 12 ماه اخیر) 
            </h2>

            

            
            <div className="chart-pannel">
                <span className="chart-header"><h3>سفارش ها</h3><p>(ماهیانه)</p></span>
                <Chart type="line" data={orderschartData} options={chartOptions} />
            </div>


            <div className="chart-pannel">                
                <span className="chart-header"><h3>محصولات درخواستی</h3><p>(10 محصول  پرطرفدار)</p></span>
                <Chart type="doughnut" data={productsChartData} options={pieChartOptions} />
            </div>
            

            <div className="chart-pannel">                
                <span className="chart-header"><h3>ارتباط با فروشنده ها</h3><p>(ماهیانه / برای 4 فروشنده برتر)</p></span>
                <Chart type="bar" data={sellerschartData} options={chartOptions} />
            </div>


            <div className="chart-pannel">                
                <span className="chart-header"><h3>ثبت نام ها</h3><p>(ماهیانه)</p></span>
                <Chart type="bar" data={usersChartData} options={chartOptions} />
            </div>


            <div className="chart-pannel">
                <span className="chart-header"><h3>بازدید مقاله ها</h3><p>(20 مقاله  برتر)</p></span>
                <Chart type="bar" data={articlesChartData} options={chartOptions} />
            </div>


            



           
           

        </div>
    );
}
  
export default ManageCharts;